const STATES = {
  SRC_SET: 'src-set',
  LOAD_STARTED: 'load-started',
  METADATA_LOADED: 'metadata-loaded',
  READY_TO_PLAY: 'ready-to-play',
  SEEK_IN_PROGRESS: 'seek-in-progress',
  PLAY_REQUESTED: 'play-requested',
  WAITING: 'waiting',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended',
};

export default STATES;



// WEBPACK FOOTER //
// ./constants/engine-states.ts